export const generateYearOptions = (minYear = 2020) => {
	const currentYear = new Date().getFullYear();

	const years = [];

	// Add "All" at the top
	years.push({ label: "Semua", value: "all" });

	// Generate years from current year backward
	for (let year = currentYear; year >= minYear; year--) {
		years.push({
			label: year.toString(),
			value: year,
		});
	}

	return years;
};
